<template>
  <div class="right-arrow-wrapper">
    <img class="right-arrow" src="@/assets/lp/right_arrow.png" alt="右方向">
    <img class="bottom-arrow" src="@/assets/lp/bottom_arrow.png" alt="右方向">
  </div>
</template>

<script>
export default {
  name: 'StepArrow'
}
</script>

<style lang="scss" scoped>
.right-arrow-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 16px;
}
.right-arrow {
  width: 32px;
}
.bottom-arrow {
  width: 32px;
  display: none;
  margin: 16px 0;
}
@media screen and (max-width: 896px) {
  .right-arrow {
    display: none;
  }
  .bottom-arrow {
    display: block;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/LP/atoms/StepArrow.vue